// ** Redux
import { createAsyncThunk } from "@reduxjs/toolkit";

// ** Helpers
import { createApiCall } from "helpers/createApiCall";
import { compute as filterSexCompute } from "hooks/filters/useFilterSex";

// ############################################################

export const getHomeGallery = createAsyncThunk(
	"mainPages/home/getHomeGallery",
	createApiCall(async (props, client, getState) => {
		const currentState = getState();
		const userSearchSex = currentState.globalUser.searchSex;
		const sharedFilters = currentState.sharedFilters;
		const homepageMediaType = currentState.mainPageHome.mediaType;
		const viewType = currentState.globalViewTypes.sharedGalleryViewType;

		let format = "short";
		if (viewType === "list") {
			format = "no-comments";
		}

		const searchSexFinal =
			props.filters?.sex ||
			sharedFilters?.searchSex ||
			userSearchSex ||
			null;
		const mediaTypeFinal = props.filters?.mediaType || homepageMediaType;

		const periodFinalApi = props.filters?.year
			? {
					year:
						props.filters?.year === "total"
							? "any"
							: props.filters?.year,
					month: "any",
				}
			: props.filters?.period
				? {
						year: props.filters?.period.selectedDate.year,
						month: props.filters?.period.selectedDate.month,
						day: props.filters?.period.selectedDate.day,
					}
				: {
						year:
							sharedFilters.period.selectedDate.year === "total"
								? "any"
								: sharedFilters.period.selectedDate.year,
						month:
							sharedFilters.period.period === "latest"
								? 0
								: sharedFilters.period.selectedDate.month,
						day: sharedFilters.period.selectedDate.day,
					};
		const periodFinalState = props.filters?.year
			? {
					selectedDate: {
						year: props.filters?.year,
						month: null,
						day: null,
					},
					period: `${props.filters?.year}`,
					year: props.filters?.year,
				}
			: props.filters?.period
				? {
						selectedDate: {
							year: props.filters?.period.selectedDate.year,
							month: props.filters?.period.selectedDate.month,
							day: props.filters?.period.selectedDate.day,
						},
						period: `${props.filters?.period.period}`,
						year: props.filters?.period.selectedDate.year,
					}
				: undefined;

		const locationFinalApi = props.filters?.location
			? {
					city: props.filters?.location?.cityId,
					region: props.filters?.location?.regionId,
					country: props.filters?.location?.country,
					distance: props.filters?.location?.distance,
				}
			: {
					city: sharedFilters.location.cityId,
					region: sharedFilters.location.regionId,
					country: sharedFilters.location.country,
					distance: sharedFilters.location.distance,
				};

		const locationFinalState = props.filters?.location
			? {
					cityId: props.filters?.location?.cityId,
					cityName: props.filters?.location?.cityName,
					regionId: props.filters?.location?.regionId,
					regionName: props.filters?.location?.regionName,
					country: props.filters?.location?.country,
					countryName: props.filters?.location?.countryName,
					distance: props.filters?.location?.distance,
					showError: props.filters?.location?.showError,
					url: props.filters?.location?.url,
				}
			: sharedFilters.location;

		const fromServer = props.fromServer;
		const infinityScroll = props.infinityScroll;
		const filtersMd5Hash = props.filtersMd5Hash;

		const response = await client.get("/media/all", {
			params: {
				page: props.params?.page || 1,

				format: format,
				type: mediaTypeFinal,
				addMinDates: true,
				sex: filterSexCompute(true).urlToApiParam(
					searchSexFinal.join("-"),
				),
				...locationFinalApi,
				...periodFinalApi,
			},
		});

		return {
			...response.data,
			fromServer,
			infinityScroll,
			filtersMd5Hash,
			counters: response.counters,
			filters: {
				mediaType: mediaTypeFinal,
				searchSex: searchSexFinal,
				location: locationFinalState,
				period: periodFinalState,
			},
		};
	}),
	{
		getPendingMeta: ({ arg }) => {
			return {
				infinityScroll: arg.infinityScroll,
				mediaType: arg?.filters?.mediaType || null,
			};
		},
	},
);

// ############################################################
